// extracted by mini-css-extract-plugin
export default {"NotFoundPageWrapper":"NotFoundPages_NotFoundPageWrapper__A6fv7","NotFoundContentWrapper":"NotFoundPages_NotFoundContentWrapper__6qbse"};